import type { PropsWithChildren } from "react";
import { AdminPanelSidebar } from "./admin-panel-sidebar.tsx";

export function AdminPanelLayout({ children }: PropsWithChildren) {
    return (
        <div className="flex h-screen w-full">
            <AdminPanelSidebar />
            <main className="flex-1 overflow-auto my-10 md:my-0">
                {children}
            </main>
        </div>
    );
}

export default AdminPanelLayout;
